import filters from "./product-filters";

let elements = document.querySelectorAll(".js-filter");
let filterSettings: any = [];
let myFilterItems: any = {};

Array.prototype.forEach.call(elements, function (el: any, i: any) {
    myFilterItems = el.name;
    filterSettings.push(
        [(state: any) => state.myCheckboxItem, myFilterItems, "js-" + myFilterItems + "-filter", myFilterItems]
    );
})

function removeDuplicated(arr: any) {
    let known: any = [];
    return arr.filter((elem: any) => {
        let str = JSON.stringify(elem);
        if (!known.includes(str)) {
            known.push(str);
            return true;
        }
        return false;
    });
}

filters.initFilters(removeDuplicated(filterSettings), "/productrangenode/search/");
